import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../components/block/Block';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import {Card} from 'reactstrap';
import {Pagination} from '../../../components/pagination/Pagination';
import TargetGroupsTable from './components/TargetGroupsTable';
import {targetGroupsApi} from '../../../api';
import {ITargetGroups} from './interfaces/ITargetGroups';
import {usePagination} from '../../../shared/hooks/usePagination';
import TargetGroupsFilters from './components/TargetGroupsFilters';
import {useTranslation} from 'react-i18next';

const TargetGroups = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [targetGroupsList, setTargetGroupsList] = useState<ITargetGroups[]>([]);
  const {changeFilterHandler, page, setTotalPages, totalPages, handlePages, pagination} = usePagination();

  useEffect(() => {
    async function getAllTargetGroups() {
      const {data} = await targetGroupsApi.getAllTargetGroups(pagination);
      setTargetGroupsList(data.data);
      setTotalPages(Math.ceil(data?.count / data?.perPage));
    }

    getAllTargetGroups();
  }, [pagination, setTotalPages]);
  return (
    <>
      <Block size="lg" className="mt-3">
        <BlockHead>
          <BlockHeadContent>
            <div className="row align-items-center gx-0 gx-lg-2">
              <div className="col-xxl-10 col-xl-9 col-lg-8 col-12">
                <BlockTitle tag="h4">{t('administrator.targetGroups.targetGroupsList')}</BlockTitle>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-4 col-12  text-end">
                <Button
                  className="btn-block"
                  color="primary"
                  onClick={() => {
                    navigate('/app/admin/target-groups/create');
                  }}
                >
                  <Icon name="plus-sm" />
                  {t('administrator.targetGroups.addNew')}
                </Button>
              </div>
            </div>
            <TargetGroupsFilters changeFilterHandler={changeFilterHandler} pagination={pagination} />
          </BlockHeadContent>
        </BlockHead>
        <Card className="card-bordered card-preview ">
          <TargetGroupsTable targetGroupsList={targetGroupsList} setTargetGroupsList={setTargetGroupsList} />
        </Card>
      </Block>

      <div className="d-flex justify-content-end">
        {totalPages <= 1 ? '' : <Pagination page={page} totalPages={totalPages} handlePagination={handlePages} />}
      </div>
    </>
  );
};

export default TargetGroups;
